export enum otpTypeSender {
  SMS,
  EMAIL
}
